// NOTE: Solution found on https://stackoverflow.com/a/4312956
export const getMonthGap = (dateFrom: Date, dateTo: Date): number => {
    return dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear());
};
